import { render } from "./forminput.vue?vue&type=template&id=baab28a2"
import script from "./forminput.vue?vue&type=script&lang=js"
export * from "./forminput.vue?vue&type=script&lang=js"

import "./forminput.vue?vue&type=style&index=0&id=baab28a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__